import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const documentEndpoint = '/api/poaDocumentosMedios';
const documentEndpoint2 = '/api/poaDocumentosMediosPO';

// Función para obtener datos de POA enviando el 'path' en el cuerpo de la solicitud
export const fetchPoaDataByPath = async (path) => {
  try {
    // Log para verificar el valor del 'path' antes de la solicitud

    // Realiza una solicitud POST enviando el 'path' en el cuerpo
    const response = await axios.post(`${baseUrl}${documentEndpoint}`, { path });

    return response.data; // Retorna los documentos obtenidos
  } catch (error) {
    console.error('Error fetching POA data by path:', error);
    throw error;
  }
};



export const getDataFilePO = async (oidIndicador) => {
  try {
    // Hacemos la petición GET pasando codIndicador en la query string
    const response = await axios.get(
      `${baseUrl}${documentEndpoint2}`,
      {
        params: { codIndicador: oidIndicador },
        validateStatus: (status) => true, // Permitimos manejar todos los status manualmente
      }
    );

    // response.status puede ser 200, 400, 500, etc.
    switch (response.status) {
      case 200:
        // OK: devolvemos los datos
        return response.data;

      case 400:
        // Error de validación por parámetro
        throw new Error('400: El parámetro codIndicador debe ser un número válido.');

      case 500:
        // Error interno del servidor
        throw new Error('500: Error interno al obtener documentos.');

      default:
        // Cualquier otro código de error
        throw new Error(`${response.status}: Error inesperado al obtener documentos.`);
    }
  } catch (error) {
    // Si axios lanza un error antes de recibir respuesta (p.ej. sin conexión), aquí lo capturamos:
    if (error.response) {
      // Ya manejamos los status en el switch, pero por seguridad:
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
      throw error;
    } else {
      // Errores de red, timeout, etc.
      console.error('Error de conexión o inesperado:', error.message);
      throw error;
    }
  }
};